import { SustainabilityScanFormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';
import { useSustainabilityScanFormFieldsConfig } from '../config';

const getDefaultValues = (intl: IntlShape): SustainabilityScanFormFields => {
  const sustainabilityScanFormFieldsConfig = useSustainabilityScanFormFieldsConfig(intl);
  return {
    houseNumber: sustainabilityScanFormFieldsConfig.houseNumber.defaultValue,
    houseNumberAddition: sustainabilityScanFormFieldsConfig.houseNumberAddition.defaultValue,
    postalCode: sustainabilityScanFormFieldsConfig.postalCode.defaultValue,
    acceptShareDetails:
      sustainabilityScanFormFieldsConfig.acceptShareDetails.defaultValue === 'true',
    acceptConditions: sustainabilityScanFormFieldsConfig.acceptConditions.defaultValue === 'true'
  };
};

export { getDefaultValues };
